// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-invalid[data-v-68a5bf40] {\n  background-color: pink !important;\n}", ""]);
// Exports
module.exports = exports;
